export default {
    "搜索问题关键词": "搜索問題關鍵詞",
    "常见问题": "常見問題",
    "已解决": "已解決",
    "未解决": "未解決",
    "更多问题，可以点开小游戏右上角三个点，选择问题与反馈进行提交": "更多問題，可以點開小遊戲右上角三個點，選擇問題與反饋進行提交",
    "其他相关问题": "其他相關問題",
    "暂无相关问题": "暫無相關問題",
    "是否需要反馈问题?": "是否需要反饋問題?",
    "更多问题，可以点击\"问题反馈\"进行提交": "更多問題，可以點擊\"問題反饋\"進行提交",
    "确定": "確定",
    "取消": "取消",
    "问题反馈": "問題反饋",
    "中文": "中文"
}


// WEBPACK FOOTER //
// ./src/vuex/i18n/zh-Hant_i18n.js